import * as React from "react";
import {ActionPlugin, default as pluginRegistry, FeaturePlugin} from "../Actions/pluginRegistry";
import {ActionEditorProps} from "components/ActionEditor/ActionEditor";

interface FeatureEditorProps extends ActionEditorProps {
    enabledFeatures: string;
}

interface FeatureEditorState {
    plugins: FeaturePlugin[];
}

export default class FeatureEditor extends React.Component<FeatureEditorProps, FeatureEditorState> {
    constructor(props: FeatureEditorProps) {
        super(props);
        this.state = {
            plugins: []
        };
    }
    componentDidMount() {
        this.refreshPlugins(this.props.enabledFeatures);
    }

    componentWillReceiveProps(newProps: FeatureEditorProps) {
        if (newProps.enabledFeatures !== this.props.enabledFeatures) {
            this.refreshPlugins(newProps.enabledFeatures);
        }
    }

    render() {
        return <div>
        {this.state.plugins.map(plugin => {
            return <plugin.edit
                key={"featureeditor-" + plugin.featureName}
                plugin={this.props.plugin}
                projectId={this.props.projectId}
                localNames={this.props.localNames}
                properties={this.props.properties}
                doBusyTask={this.props.doBusyTask}
                setProperties={this.props.setProperties}
                getFieldError={this.props.getFieldError}
                errors={this.props.errors}
            />;
        })}
        </div>;
    }

    private refreshPlugins(enabledFeatures: string) {
        const featureNames = (enabledFeatures || "").split(",");

        const allFeatures = pluginRegistry.getAllFeatures();

        const plugins: FeaturePlugin[] = [];

        allFeatures.forEach((feature) => {
            const isEnabled = featureNames.includes(feature.featureName);
            if (!isEnabled) {
                return;
            }
            plugins.push(feature);
        });
        this.setState({plugins});
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/FeatureEditor/FeatureEditor.tsx